export default {
  'beforeYouBegin': {
    header: '(SP) Before You Begin',
  },
  'byb-step-3': {
    'header': '(SP) Recruit Information',
    'contactPresentQuestion':
      '(SP) Are you completing this IBA using a 3rd party web conferencing tool and therefore you are not physically with the Applicant?',
    'contactRecentlyEmployedQuestion': '(SP) Is the recruit currently employed?',
    'contactAffiliateQuestion':
      '(SP) Please select “Yes” if the recruit was an agent with one of the following affiliates or prior companies:  A. L. Williams, MILICO, National Benefit Life, Primerica, Primerica Life Insurance Company, and Primerica Financial Services of New York.',
    'contactAffiliateSolutionNumber.label': '(SP) Rep ID',
    'contactAffiliateSolutionNumber.error.minlength': '(SP) Agent Number must be 5 Characters',
    'contactAffiliateSolutionNumber.error.pattern': '(SP) Only AlphaNumeric Characters allowed.',
  },
  'continue': 'Continuar',
  'Back': 'Regresar',

  // For onex-ui-lib
  'COMP_YES': 'Sí',
  'COMP_NO': 'No',
  'COMP_DATE_OF_BIRTH': 'Fecha de Nacimiento',
  'L_POL_FIRST_NAME': 'Nombre',
  'L_POL_LAST_NAME': 'Apellido',
};
